const accessRoute = {
  Resume_Details: {
    path: "/admin/resume-details",
  },
};
export default accessRoute;
